// extracted by mini-css-extract-plugin
export default {"span":"src-components-Page-Page__span","main":"src-components-Page-Page__main","loading":"src-components-Page-Page__loading"};